/**
 * MasterDataReloadContext — cầu nối để nút Reload ở HEADER CHUNG (`MasterDataPage`,
 * cùng dòng với "Master Data — <Page>") gọi được hàm fetch lại data của page con
 * đang hiển thị.
 *
 * Cơ chế: page con (view) đăng ký `{ onReload, loading }` qua `useMasterDataReload`;
 * `MasterDataPage` nhận và render nút Reload cạnh title. Page con không cần render
 * nút — chỉ khai báo hook là header tự có Reload. Áp dụng dần cho từng page khi cần.
 */
import { createContext, useContext, useEffect } from 'react'

export interface MasterDataReloadApi {
  onReload: () => void
  loading: boolean
}

/** Register callback do `MasterDataPage` cung cấp; null = page không có Reload. */
export type RegisterMasterDataReload = (api: MasterDataReloadApi | null) => void

export const MasterDataReloadContext = createContext<RegisterMasterDataReload | null>(null)

/**
 * Page con gọi hook này để header chung hiện nút Reload gắn với refetch của nó.
 * `onReload` nên ổn định (useCallback bọc `refetch`); `loading` = isFetching.
 */
export function useMasterDataReload(onReload: () => void, loading: boolean): void {
  const register = useContext(MasterDataReloadContext)
  useEffect(() => {
    if (!register) return
    register({ onReload, loading })
    return () => register(null)
  }, [register, onReload, loading])
}
